module.exports = __webpack_public_path__ + "img/Korean Meal-Tofu.7589910e.jpg";